export const NON_CLIENT_ROUTES = [
  '/clients',
  '/beacon/insights',
  '/accounting',
  '/nps-report',
  '/metrics',
  '/manuals',
  '/audit',
  '/login',
  '/profile',
  '/settings',
  '/invite',
  '/demo',
  '/feedback',
  '/voice',
  '/about',
  '/deletion',
  '/forgot-password',
  '/password',
  '/twofa',
  '/unauthorized',
  '/login-success',
  '/resources',
];

export const isNonClientRoute = (path: string): boolean =>
  NON_CLIENT_ROUTES.some(
    (route) =>
      path === route ||
      path.startsWith(route + '/') ||
      path.startsWith(route + '?')
  );

/**
 * Splits an app path into the client it belongs to and the page within it.
 * `/<encryptedClientId>/nova` -> `{ encryptedClientId, page: '/nova' }`.
 */
export const splitClientPath = (
  path: string
): { encryptedClientId: string | null; page: string } => {
  const [first, ...rest] = path.split('/').filter(Boolean);
  if (!first || isNonClientRoute('/' + first)) {
    return { encryptedClientId: null, page: path };
  }
  return { encryptedClientId: first, page: '/' + rest.join('/') };
};
